// extracted by mini-css-extract-plugin
module.exports = {"s1ftnewk":"s1ftnewk","syx89jc":"syx89jc"};